import React from "react";
import styles from "../assets/css/viodeBanner.module.scss";
import {Container, Typography} from "@mui/material";
import Button1 from "./subComponents/Button1";
import Button2 from "./subComponents/Button2";
import {useNavigate} from "react-router-dom"

const VideoBanner = (props) => {
    const navigate = useNavigate();

    return <div className={styles.container}>

        <div className={styles.overlay}></div>
        <video autoPlay muted loop src={props.video}/>
        <div className={styles.titleContainer}>
            <Container maxWidth={"md"}>
                <Typography variant="h4" gutterBottom className={styles.title}>{props.title1}</Typography>
                <Typography variant="body2" gutterBottom className={styles.title}>{props.title2}</Typography>
                <div className={styles.itemContainer}>
                    {props.showButton1 && <Button1 variant="contained"
                                                   onClick={() => navigate(props.Button1Link)}>
                        {props.Button1Text}</Button1>}
                    {props.showButton2 && <Button2 variant="outlined"
                                                   onClick={() => navigate(props.Button2Link)}>
                        {props.Button2Text}</Button2>}
                </div>


            </Container>
        </div>

    </div>;
};

export default VideoBanner;